module.exports = __webpack_public_path__ + "img/chongdianzhuang.09ffc2e4.png";